import React, { Component } from 'react';
import { NumberInput } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { getByDmService } from '../services/Api';

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imagem: '',
    };
  }

  componentWillMount = async () => {
    const { imagem, id } = this.props;
    this.setState({ imagem });
    await this.getItem(id);
  };

  getItem = async id => {
    try {
      const produto = await getByDmService('/Produto', id);
      this.setState({ ...produto });
    } catch (ex) {
      toast.error('Ocorreu uma falha ao processar a requisição');
    }
  };

  setImagem = img => {
    this.setState({ imagem: img });
  };

  thumbs() {
    const { fotos } = this.state;
    return (
      fotos &&
      fotos.map(img => (
        <div key={img.id} className="pointer bx--col-xs-3  bx--col-md-12">
          <img
            onClick={() => this.setImagem(img.caminho)}
            className="img-responsive img-galery"
            alt="thumbnail"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
            style={{ backgroundImage: `url('${img.caminho}')` }}
          />
        </div>
      ))
    );
  }

  render() {
    const { nome, produtoCategoria, descricao, estoque, imagem, preco } = this.state;
    return (
      <div className="bx--row">
        <div className="bx--col-xs-12  bx--col-md-1 bx--col-xl-2 bx--col-xxl-3">
          <div className="bx--row">{this.thumbs()}</div>
        </div>
        <div className="bx--col-xs-12  bx--col-md-6  bx--col-xl-5 bx--col-xxl-4 mg-bt-24 ">
          <img
            className="img-responsive img-force"
            alt="thumbnail"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
            style={{ backgroundImage: `url('${imagem}')` }}
          />
        </div>
        <div className="bx--col-xs-12 bx--col-md-5 text-right description-breadcrumb">
          <a className="link-thumb">{(produtoCategoria || { NOME: '' }).nome}</a>
          <p className="title-thumb">{nome}</p>
          <p className="product-desc">{descricao}</p>
          <p className="price-thumb">
            R$
            {preco}
          </p>
          <div className="quantity-thumb mg-top-30">
            <strong>Quantidade</strong>
            <br />
            <NumberInput
              className="some-class"
              id="tj-input"
              step={1}
              invalidText="Somente números são válidos"
            />
          </div>
          <div className="clearfix" />
          <div className="quantity-thumb mg-top-10 crear-fix">
            <label>
              {estoque}
              {' em estoque'}
            </label>
          </div>
          <button className="bx--btn btn-secondary-color btn-lg opcity add-to-cart" type="button">
            Adicionar ao carrinho - R$ 120, 00
          </button>
        </div>
      </div>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery.js